<template>
    <div class="main box">
        <h1>Documentation</h1>
        <posts-table cat="6"></posts-table>
    </div>
</template>

<script>

import PostsTable  from "../components/PostsTable.vue";

export default {
    name : "Documents",
    components : { PostsTable },

}
</script>

<style lang="scss" scoped>
  h1 {
    color:#fff;
    text-align: center;
    font-size:25px;
    text-transform: uppercase;
    font-weight: 300;
    margin:40px auto;
  }
</style>